import { render } from "./assets-list.vue?vue&type=template&id=b3afcb86&scoped=true"
import script from "./assets-list.vue?vue&type=script&lang=js"
export * from "./assets-list.vue?vue&type=script&lang=js"

import "./assets-list.vue?vue&type=style&index=0&id=b3afcb86&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3afcb86"]])

export default __exports__